'use client';
import React, { useEffect } from 'react';
import ButtonGroupItem from '../ButtonGroupItem/ButtonGroupItem';

interface AnchorNavBarProps {
	buttons: string[];
	onButtonClick: (categoryTitle: string) => void;
	activeButton?: string;
}

const AnchorNavBar: React.FC<AnchorNavBarProps> = ({ buttons, onButtonClick, activeButton }) => {

	// Unfocus all buttons when active button changes
	useEffect(() => {
		if (document.activeElement instanceof HTMLElement) {
			document.activeElement.blur();
		}
	}, [activeButton]);

	return (
		<div className='
			w-fit
			bg-bg-light-primary
			outline-main
			outline-stroke-soft-200
			rounded-full
			py-[0.5rem]
			px-[0.5rem]
			flex flex-row gap-[0.25rem]

			'>
			{buttons &&
				buttons.map(button => (
					<ButtonGroupItem
						key={button}
						text={button}
						itemType='narrow'
						size={16}
						isSelected={activeButton === button}
						onClick={() => {
							onButtonClick(button);
						}}
					/>
				))
			}
		</div>
	);

};


export default AnchorNavBar;

